import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const React = require("react");
import { allLocationsId, allLocationsLabel } from "../../../../backendApi/CollectionApi";
import { pushCollectionAction } from "../../CollectionUtils";
export const LocationFilter = (param)=>{
    let { Locations, activeLocation, updateLocation, preferredBranchId } = param;
    const orderedLocations = [
        ...Locations
    ].sort((a, b)=>a.Name.localeCompare(b.Name));
    const preferredIndex = preferredBranchId ? orderedLocations.findIndex((location)=>location.Id === preferredBranchId) : -1;
    const sortedLocations = preferredIndex > -1 ? [
        orderedLocations[preferredIndex],
        ...orderedLocations.filter((_, index)=>index !== preferredIndex)
    ] : orderedLocations;
    const push = pushCollectionAction();
    return /*#__PURE__*/ _jsxs("div", {
        className: `c-filter__group c-filter__group--location`,
        children: [
            /*#__PURE__*/ _jsx("h3", {
                className: "c-filter__group-title",
                children: "Locatie"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "c-filter__select form__select collection__queryfield",
                children: /*#__PURE__*/ _jsxs("select", {
                    id: "collection-loc",
                    className: "form__input",
                    onChange: (e)=>{
                        e.preventDefault();
                        push('filter-location', e.target.selectedOptions[0].text);
                        updateLocation(e.target.value);
                    },
                    value: activeLocation || allLocationsId,
                    children: [
                        /*#__PURE__*/ _jsx("option", {
                            value: allLocationsId,
                            children: allLocationsLabel
                        }, "any-location"),
                        sortedLocations.map((location)=>/*#__PURE__*/ _jsxs("option", {
                                value: location.Id,
                                className: location.Id === preferredBranchId ? 'option--preferred' : undefined,
                                children: [
                                    location.Name,
                                    location.Id === preferredBranchId ? ' (mijn bieb)' : ''
                                ]
                            }, `location__${location.Id}`))
                    ]
                })
            })
        ]
    });
};
